import { Component, OnInit, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ErrorComponent } from '../error/error.component';
import { HeaderBarComponent } from '../header-bar/header-bar.component';
import { License, SbomService } from '../../services/sbom.service';
import { forkJoin } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  imports: [TranslatePipe, ErrorComponent, HeaderBarComponent],
})
export class LicensesComponent implements OnInit {
  private service = inject(SbomService);

  loading = true;

  error: HttpErrorResponse | null = null;

  serverLicenses: License[] = [];

  serverDependenciesCount = 0;

  clientLicenses: License[] = [];

  clientDependenciesCount = 0;

  ngOnInit(): void {
    forkJoin({
      server: this.service.getServerLicenses(),
      client: this.service.getClientLicenses(),
    }).subscribe({
      next: ({ server, client }) => {
        this.serverLicenses = server;
        this.serverDependenciesCount = this.serverLicenses.reduce(
          (acc, license) => acc + license.dependencies.length,
          0,
        );
        this.clientLicenses = client;
        this.clientDependenciesCount = this.clientLicenses.reduce(
          (acc, license) => acc + license.dependencies.length,
          0,
        );
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.error = error;
        this.loading = false;
      },
    });
  }
}
